/* BEGIN_COPYRIGHT_HEADER

Copyright Vspry International Limited (c) 2020
All rights reserved.

END_COPYRIGHT_HEADER */

import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from 'context/authContext'

export default function PrivateRoute() {
    const { identity } = useAuth()
    const location = useLocation()

    if (identity) return <Outlet />
    return <Navigate to={`/?redirect=${encodeURIComponent(location.pathname)}${encodeURIComponent(location.search)}`} />
}
